import { TldrawOptions, TLUiComponents } from '@tldraw/tldraw';
import { CustomToolbar } from 'src/screens/management/contents/main-visual/section/tldraw/CustomTldraw';

import { DEVICE_DIMENSIONS, TDeviceType } from '../common';

export const TLDRAW_CONFIG = {
  // overrides: {
  //   uiOverrides,
  // } as Partial<TLUiOverrides>,
  components: {
    PageMenu: null,
    Toolbar: CustomToolbar,
    // StylePanel: CustomStylePanel,
    // InFrontToolbar: ContextToolbarComponent as TLEditorComponents,
    // StylePanel: ContextToolbarComponent,
  } as Partial<TLUiComponents>,
  options: {
    maxPages: 1,
  } as Partial<TldrawOptions>,
} as const;

// 고정 요소 위치 설정 - 퍼센트 기반 위치로 변경
export const FIXED_POSITIONS = {
  mainText: {
    x: '15%',
    y: '20%',
    width: '76%',
    height: '20%',
  },
  subText: {
    x: '15%',
    y: '30%',
    width: '76%',
    height: '8%',
  },
  getMediaPosition: (device: TDeviceType) => {
    const deviceBounds = DEVICE_DIMENSIONS[device];
    return {
      x: 0,
      y: 0,
      w: deviceBounds.width,
      h: deviceBounds.height,
    };
  },
} as const;

// TODO 공통 util이여도 될 것같은데 정리 필요
// HTML 문자열에서 텍스트만 추출하는 함수
export const extractTextFromHtml = (html: string): string => {
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || '';
};
